import { useMaintenanceStore } from "~/stores/useMaintenanceStore";

export default function useMaintenance() {
  const maintenanceStore = useMaintenanceStore();

  return {
    getMaintenanceMessages: maintenanceStore.getMaintenanceMessages,
    isMaintenance: maintenanceStore.isMaintenance,
    isMaintenanceClosed: maintenanceStore.isMaintenanceClosed,
    isMaintenanceWarning: maintenanceStore.isMaintenanceWarning,
    isUpcomingMaintenanceSoon: maintenanceStore.isUpcomingMaintenanceSoon,
    maintenance_start: maintenanceStore.maintenance_start,
    maintenance_end: maintenanceStore.maintenance_end,
    upcoming_start: maintenanceStore.upcoming_start,
  };
}
